import { render, staticRenderFns } from "./FloatingsV2.vue?vue&type=template&id=c0a3a9f8&"
import script from "./FloatingsV2.vue?vue&type=script&lang=js&"
export * from "./FloatingsV2.vue?vue&type=script&lang=js&"
import style0 from "./FloatingsV2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports